import MoonIcon from 'images/Moon Icon.svg'
import SunIcon from 'images/Sun Icon.svg'
import UnderlineImage from 'images/Underline Illustration v2.png'
import { Caption1 } from 'components/common/typography'
import { IconContainer, IconGroup, Underline } from './dayNightIcons_styles'

const DayNightIcons = props =>
  <IconContainer {...props}>
    <IconGroup onClick={() => props.setIsDay(true)} selected={props.isDay}>
      <img src={SunIcon} alt='daytime icon' />
      <Caption1>Daytime</Caption1>
      {props.isDay &&
        <Underline src={UnderlineImage} alt='' />
      }
    </IconGroup>
    <IconGroup onClick={() => props.setIsDay(false)} selected={!props.isDay}>
      <img src={MoonIcon} alt='nighttime icon' />
      <Caption1>Nightfall</Caption1>
      {!props.isDay &&
        <Underline src={UnderlineImage} alt='' />
      }
    </IconGroup>
  </IconContainer>

export default DayNightIcons
